/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import SimpleButton from '@components/Buttons/SimpleButton';
import SectionTitle from '@components/Headings/SectionTitle';
import SingleLineText from '@components/UI/SingleLineText';
import PracticeCurriculumCardV1 from '../components/Card/PracticeCurriculumCardV1';
import config from '@config';
/* Internal Imports */
/* Components */

/**
 * Returns the BenefitsGroup.
 * @param {Object} sectionContent - Content from API
 * @param {string} language - Language of the page
 * @param {string} region - Region of the page
 * @returns {ReactElement} Banner component
 * 
 */
const PracticeCurriculumV1 = ({ pageData, sectionContent, region, language }) => {
    const pageName = pageData?.pageConfig?.pageName

    return (
        <Box marginTop={{ sm: "", base: "", md: "0px" }} 
            bgImage={{base:'', md:`url(${config.imgPath}/d/46272/1733835026-left_practice.png)`}}
            bgRepeat={'no-repeat'}
            bgPosition={'left 20px'}
        >
            {sectionContent.map((section, index) => {
                if (section?._modelApiKey === 'section_title') {
                    return (
                        <Box key={index}>
                            <SectionTitle
                                titleObj={section}
                                titleDecoration={"none"}
                                color="white"
                                mx={{ base: '17px', md: 'auto' }}
                            />
                        </Box>
                    );
                }
                if (section?._modelApiKey === 'single_line_text') {
                    return (
                        <Box 
                            marginTop={{ base: "-10px", sm: "-10px", md: "-15px" }}
                            width={{ sm: "270px", base: "270px", md: "387px" }}
                            mx={"auto"}  
                            fontFamily="FedraSansStd-book"
                            fontWeight={{base:'400',sm:"400", lg:"350"}}
                            fontSize="18px" 
                            textAlign="center" 
                            color="#FFFFFF"
                            lineHeight={'25.2px'}
                            >
                            {sectionContent[1].text}
                        </Box>
                    )
                }

                if (section?._modelApiKey === 'card_custom_card_group') {
                    return (
                        <Box
                            maxWidth={{ base: "320px", sm: "320px", xl: "1060px" }}
                            paddingBottom={'50px'}
                            mx={"auto"}
                        >
                            <PracticeCurriculumCardV1
                                sectionContent={section}
                                pageData={pageData}
                                pageName={pageName}
                            />
                        </Box>
                    )
                }
                if (section?._modelApiKey === 'simple_button') {
                    return (
                        <Box key={index}
                            paddingTop={{ base: "20px", sm: "20px", md: "50px", lg: "50px" }}
                        // marginTop={{ base: "100px", sm: "100px", md: "50px", lg: "430px" }}

                        >
                            <SimpleButton
                                pageConfig={pageData?.pageConfig}
                                style={section}
                                region={region}
                                lang={language}
                                mx="auto"
                                width={"188px"}
                            />
                        </Box>
                    )
                }
            })}
        </Box>

    );
};

export default PracticeCurriculumV1;
